// 東莞：18922817568
// 深圳：18902313051
// 福州：17305005560
// 平潭：17305018706
// 三明：17350377728
// 上海：13918420162
const delPhons = [
  // 舊
  '15323739231',
  '13316539234',
  '18580906048',
  '13312976618',
  '18050220835',
  '13342990655',
  '18060810026',
  '18050220723',

  // 新
  // '18922817568',
  // '18902313051',
  // '17305005560',
  // '17305018706',
  // '17350377728',
  // '13918420162',
  // '18058928173',
  // '18030067359',
  // '16659000162',
  // '19359677766',
]

export function setAddr (type) {
  const vueApp = window.vueApp
  const whsItem = vueApp.$store.state.jyWarehouses
    .find(item => item.addrid === vueApp.$store.state.userData.defaultWhsAddr.addrid)
  return new Promise((resolve, reject) => {
    if (!vueApp.$store.state.installedCrx) {
      vueApp.$confirm('安裝巧巧郎的鑰匙，地址自動key入到' + (type === 'taobao' ? '淘寶' : '阿里巴巴'), {
        buttonTrueText: '前往安裝',
        buttonFalseText: '下次再說'
      }).then(r => {
        if (r) {
          window.open('https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E5%8C%85%E8%A3%B9%E7%AE%A1%E5%AE%B6/lacejchmbljdoaimkbmcflcechgndbim')
        }
      })
      reject(new Error('no install'))
    }
    window._onCrxAddrSuccess = async (type) => {
      const addrids = window.vueApp.$store.state.jyWarehouses.map(item => item.addrid)
      const userData = window.vueApp.$store.state.userData
      if (userData.syncWhsAddrids && userData.syncWhsAddrids.resets) {
        if (userData.syncWhsAddrids.resets.find(reset => reset.addrid === '1050')) {
          addrids.push('1050')
        }
      }
      await vueApp.$store.dispatch('user/usermbr/updateSyncWhsAddrids', {
        addrid: addrids.join(','),
        platform: type,
      })
      resolve({
        type,
        whsItem,
      })
    }
    const addrids = ['1024', '1596', vueApp.$store.state.userData.defaultWhsAddrid]
    const whsList = vueApp.$store.state.jyWarehouses.filter(whsItem => addrids.includes(whsItem.addrid))
    if (type === 'taobao') {
      const addrList = whsList.map(whsItem => {
        if (whsItem.addrid === '1024') {
          return {
            divisionCode: 440306021,
            townDivisionCode: 440306021,
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            longitude: '22.675986',
            latitude: '113.826755',
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            // defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            deliverId: '9843950849'
          }
        } else if (whsItem.addrid === '1210') {
          return {
            divisionCode: '310118003',
            townDivisionCode: '310118003',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            longitude: '31.161931',
            latitude: '121.164058',
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            // defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '上海',
            city: '上海市',
            area: '青浦区',
            town: '香花桥街道',
            deliverId: '14119329834'
          }
        } else if (whsItem.addrid === '1050') {
          return {
            divisionCode: '350181116',
            townDivisionCode: '350181116',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '福州市',
            area: '福清市',
            town: '江阴镇',
            deliverId: '14119329834'
          }
        } else if (whsItem.addrid === '1598') {
          return {
            divisionCode: '350423100',
            townDivisionCode: '350423100',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '三明市',
            area: '清流县',
            town: '龙津镇',
            deliverId: '18420819393'
          }
        } else if (whsItem.addrid === '1769') {
          return null
          // if (!vueApp.$store.state.userData.hasJyorder) {
          //   return null
          // }
          // return {
          //   'divisionCode': '441901122',
          //   'detailDivisionCode': '',
          //   'addressDetail': `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
          //   'postCode': whsItem.formatAddr.postcode,
          //   'overseaAddress': false,
          //   'fullName': whsItem.formatAddr.name,
          //   'mobileCode': '86',
          //   'mobile': whsItem.formatAddr.phone,
          //   'phoneInternationalCode': 86,
          //   'phoneAreaCode': '',
          //   'phoneNumber': '',
          //   'phoneExtension': '',
          //   'defaultDeliverAddress': vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
          //   'acceptAddressName': true,
          //   'province': '广东省',
          //   'city': '东莞市',
          //   'area': '',
          //   'town': '厚街镇',
          //   'deliverId': '14630804528',
          //   latitude: '113.653135',
          //   longitude: '22.864722',
          // }
        } else if (whsItem.addrid === '2769') {
          return {
            divisionCode: '441901122',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '广东省',
            city: '东莞市',
            area: '',
            town: '厚街镇',
            deliverId: '14630804528',
            latitude: '113.629522',
            longitude: '22.916477',
          }
        } else if (whsItem.addrid === '1591') {
          return {
            divisionCode: '350121104',
            townDivisionCode: '350121104',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '福州市',
            area: '闽侯县',
            town: '祥谦镇',
            deliverId: '15038695766',
            longitude: '25.937881',
            latitude: '119.363486'
          }
        } else if (whsItem.addrid === '1592') {
          return {
            divisionCode: '350205103',
            townDivisionCode: '350205103',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '厦门市',
            area: '海沧区',
            town: '东孚街道',
            deliverId: '21363715479',
            longitude: '24.572797',
            latitude: '117.967084'
          }
        } else if (whsItem.addrid === '1596') {
          return {
            divisionCode: '350681102',
            townDivisionCode: '350681102',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '漳州市',
            area: '龙海区',
            town: '角美镇',
          }
        } else if (whsItem.addrid === '3591') {
          return {
            divisionCode: '350128997',
            townDivisionCode: '350128997',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '福建省',
            city: '福州市',
            area: '平潭县',
            town: '金井镇',
          }
        } else if (whsItem.addrid === '1579' && vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid) {
          return {
            divisionCode: '330782003',
            townDivisionCode: '330782003',
            detailDivisionCode: '',
            addressDetail: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            longitude: '29.282789',
            latitude: '119.986556',
            postCode: whsItem.formatAddr.postcode,
            overseaAddress: false,
            fullName: whsItem.formatAddr.name,
            mobileCode: '86',
            mobile: whsItem.formatAddr.phone,
            phoneInternationalCode: 86,
            phoneAreaCode: '',
            phoneNumber: '',
            phoneExtension: '',
            defaultDeliverAddress: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            acceptAddressName: true,
            province: '浙江省',
            city: '金华市',
            area: '义乌市',
            town: '稠江街道',
            deliverId: '20756128057',
          }
        }
        return null
      }).filter(item => item)
      window.chrome.runtime.sendMessage(vueApp.$store.state.extId, {
        CMD: 'AddJyAddress',
        data: {
          addrList,
          delPhons: [
            ...delPhons,
            ...whsList.map(whsItem => whsItem.formatAddr.phone),
          ],
        },
      })
    } else if (type === '1688') {
      const addrList = whsList.map(whsItem => {
        if (whsItem.addrid === '1024') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 440306,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '广东省 深圳市 宝安区',
            provinceCode: 440000,
            cityCode: 440300,
            areaCode: 440306,
            townCode: 440306021,
            provinceName: '广东省',
            cityName: '深圳市',
            areaName: '宝安区',
            townName: '福海街道',
            // isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '广东省 深圳市 宝安区 福海街道',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1210') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 310118,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '上海 上海市 青浦区',
            provinceCode: 310000,
            cityCode: 310100,
            areaCode: 310118,
            townCode: 310118003,
            provinceName: '上海',
            cityName: '上海市',
            areaName: '青浦区',
            townName: '香花桥街道',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '上海 上海市 青浦区 香花桥街道',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1598') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350423,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 三明市 清流县',
            provinceCode: 350000,
            cityCode: 350400,
            areaCode: 350423,
            townCode: 350423100,
            provinceName: '福建省',
            cityName: '三明市',
            areaName: '清流县',
            townName: '龙津镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 三明市 清流县 龙津镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1050') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350181,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 福州市 福清市',
            provinceCode: 310000,
            cityCode: 310100,
            areaCode: 310118,
            townCode: 310118003,
            provinceName: '福建省',
            cityName: '福州市',
            areaName: '福清市',
            townName: '江阴镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 福州市 福清市 江阴镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1769') {
          if (!vueApp.$store.state.userData.hasJyorder) {
            return null
          }
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 441900,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '广东省 东莞市',
            provinceCode: 440000,
            cityCode: 441900,
            areaCode: '',
            townCode: 441901122,
            provinceName: '广东省',
            cityName: '东莞市',
            areaName: '',
            townName: '厚街镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '广东省 东莞市 厚街镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '2769') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 441900,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '广东省 东莞市',
            provinceCode: 440000,
            cityCode: 441900,
            areaCode: '',
            townCode: 441901122,
            provinceName: '广东省',
            cityName: '东莞市',
            areaName: '',
            townName: '厚街镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '广东省 东莞市 厚街镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1591') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350121,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 福州市 闽侯县',
            provinceCode: 350000,
            cityCode: 350100,
            areaCode: 350121,
            townCode: 350121104,
            provinceName: '福建省',
            cityName: '福州市',
            areaName: '闽侯县',
            townName: '祥谦镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 福州市 闽侯县 祥谦镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1592') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350205,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 厦门市 海沧区',
            provinceCode: 350000,
            cityCode: 350200,
            areaCode: 350205,
            townCode: 350205103,
            provinceName: '福建省',
            cityName: '厦门市',
            areaName: '海沧区',
            townName: '东孚街道',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 厦门市 海沧区 东孚街道',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1596') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350681,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 漳州市 龙海区',
            provinceCode: 350000,
            cityCode: 350600,
            areaCode: 350681,
            townCode: 350681102,
            provinceName: '福建省',
            cityName: '漳州市',
            areaName: '龙海区',
            townName: '角美镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 漳州市 龙海区 角美镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '3591') {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 350128,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '福建省 福州市 平潭县',
            provinceCode: 350000,
            cityCode: 350100,
            areaCode: 350128,
            townCode: 350128997,
            provinceName: '福建省',
            cityName: '福州市',
            areaName: '平潭县',
            townName: '金井镇',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '福建省 福州市 平潭县 金井镇',
            operateType: 'add',
          }
        } else if (whsItem.addrid === '1579' && vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid) {
          return {
            fullName: whsItem.formatAddr.name,
            address: `${whsItem.desc}-${vueApp.$store.state.userData.uid}號`,
            addressCode: 330782,
            mobile: whsItem.formatAddr.phone,
            phone: '',
            phoneCode: '',
            phoneNumber: '',
            phoneSubCode: '',
            postCode: whsItem.formatAddr.postcode,
            addressCodeText: '浙江省 金华市 义乌市',
            provinceCode: 330000,
            cityCode: 330700,
            areaCode: 330782,
            townCode: 330782003,
            provinceName: '浙江省',
            cityName: '金华市',
            areaName: '义乌市',
            townName: '稠江街道',
            isDefault: vueApp.$store.state.userData.defaultWhsAddrid === whsItem.addrid,
            isInland: true,
            addressNamePath: '浙江省 金华市 义乌市 稠江街道',
            operateType: 'add',
          }
        }
        return null
      }).filter(item => item)
      // console.log('AddJyAddress1688', addrList)
      window.chrome.runtime.sendMessage(vueApp.$store.state.extId, {
        CMD: 'AddJyAddress1688',
        data: {
          addrList,
          delPhons: [
            ...delPhons,
            ...whsList.map(whsItem => whsItem.formatAddr.phone),
          ],
        },
      })
    }
  })
}

export function fetchGoods (data) {
  return new Promise((resolve, reject) => {
    window._onCrxFetchGoodsSuccess = async (data) => {
      resolve(data)
    }
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'START_FETCH_GOODS',
      data: {
        ...data,
        accessToken: localStorage.accessToken,
      },
    })
  })
}

export function fetchTbCartData (data) {
  return new Promise((resolve, reject) => {
    window._onCrxFetchTbCartDataSuccess = async (data) => {
      resolve(data)
    }
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'FetchTbCartData',
      data: {},
    })
  })
}

export function fetchAliCartData (data) {
  return new Promise((resolve, reject) => {
    window._onCrxFetchAliCartDataSuccess = async (data) => {
      resolve(data)
    }
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'FetchAliCartData',
      data: {},
    })
  })
}

export function fetchTbQualificationInfo (data) {
  return new Promise((resolve, reject) => {
    window._onCrxFetchQualificationInfoSuccess = async (data) => {
      resolve(data)
    }
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'FetchTbQualificationInfo',
      data,
    })
  })
}

export function fetchAliQualificationInfo (data) {
  return new Promise((resolve, reject) => {
    window._onCrxFetchQualificationInfoSuccess = async (data) => {
      resolve(data)
    }
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'FetchAliQualificationInfo',
      data,
    })
  })
}

export function getAllCrx () {
  return new Promise((resolve) => {
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'getAllCrx'
    }, reply => {
      resolve(reply)
    })
  })
}

export function axiosRequest (data) {
  return new Promise((resolve) => {
    window.chrome.runtime.sendMessage(window.vueApp.$store.state.extId, {
      CMD: 'axiosRequest',
      data,
    }, reply => {
      resolve(reply)
    })
  })
}

function handerMessage (e) {
  if (e.data.action === 'addAddressSuccess') {
    if (window._onCrxAddrSuccess) {
      window._onCrxAddrSuccess(e.data.data.type)
    }
  } else if (e.data.action === 'FetchGoodsData') {
    console.log('FetchGoodsData', e.data)
    if (window._onCrxFetchGoodsSuccess) {
      window._onCrxFetchGoodsSuccess(e.data.data)
    }
  } else if (e.data.action === 'receiveCartData') {
    // console.log('receiveCartData', e.data)
    if (window._onCrxFetchTbCartDataSuccess) {
      window._onCrxFetchTbCartDataSuccess(e.data.data)
    }
  } else if (e.data.action === 'receiveAliCartData') {
    if (window._onCrxFetchAliCartDataSuccess) {
      window._onCrxFetchAliCartDataSuccess(e.data.data)
    }
  } else if (e.data.action === 'receiveQualificationInfo') {
    if (window._onCrxFetchQualificationInfoSuccess) {
      window._onCrxFetchQualificationInfoSuccess(e.data.data)
    }
  }
}

let checkTimer = 0
let checkCount = 0
async function checkInstallCrx () {
  checkCount++
  if (await window.vueApp.$store.dispatch('checkInstallCrx')) {
    if (checkCount > 1) {
      location.reload()
    }
    window.addEventListener('message', handerMessage)
    clearInterval(checkTimer)
  }
}

setTimeout(() => {
  if (window.vueApp.$store.state.isChrome) {
    checkInstallCrx()
    checkTimer = setInterval(async () => {
      checkInstallCrx()
    }, 5000)
  }
})
